<rappider-modal [(visible)]="modalVisibility"
                [title]="modalTitle"
                [footer]="null"
                className="ai-content-config-modal"
                (visibleChange)="handleModalVisibility($event)">
  <rappider-crud-view-edit-form [config]="formConfig"
                                [data]="data"
                                (formSubmit)="onFormSubmit($event)"></rappider-crud-view-edit-form>
</rappider-modal>
